import {useEffect, useState} from 'react';

const isDev = process.env.ENV_TYPE === 'dev';

/**
 * Hook that listens to localStorage changes for the "featureFlagMock" key
 * and triggers a re-render when the value changes.
 *
 * Handles both cross-tab changes (via storage event) and same-tab changes (via custom event).
 *
 * @returns A counter value that changes when the featureFlagMock localStorage item changes
 */
export const useFeatureFlagMockListener = () => {
  const [refreshCounter, setRefreshCounter] = useState(0);

  const triggerRerender = () => {
    setRefreshCounter((prev) => prev + 1);
  };

  useEffect(function subscribeToFeatureFlagMock() {
    if (!isDev) {
      return;
    }

    // Handle same-tab localStorage changes via custom event
    const handleCustomEvent = () => {
      triggerRerender();
    };

    window.addEventListener('featureFlagMock', handleCustomEvent);

    return () => {
      window.removeEventListener('featureFlagMock', handleCustomEvent);
    };
  }, []);

  return refreshCounter;
};
